<template>
  <div id="lineChart"></div>
</template>

<script>
export default {
  props: [
    'data',
  ],
  computed: {
    getData(){
      return this.data;
    }
  },
  mounted(){
    const data = this.data;
    let dataset = [];

    data.forEach((el, i)=>{
      const getData = {
        date : el.challenge_date.substr(5,5),
        value: el.desire_percentage,
      };
      dataset.push(getData);
    });

    const element = `
      <div class="grid">
        <div class="persent"></div>
        <div class="date"></div>
        <div class="point"></div>
      </div>
    `;
    document.querySelector('#lineChart').innerHTML = element;

    const persent = [0, 20, 40, 60, 80, 100];
    persent.reverse();
    persent.forEach((el)=>{
      const createElement = document.createElement('div');
      createElement.innerHTML = el + '%';
      document.querySelector('.persent').append(createElement);
    });
    dataset.forEach((el, i)=>{
      const createElement = document.createElement('div');
      createElement.innerHTML = el.date;
      document.querySelector('.date').append(createElement);

      const createElement2 = document.createElement('div');
      createElement2.className = 'pointBox';
      document.querySelector('.point').append(createElement2);
      
      const pointBoxElement = document.querySelectorAll('.pointBox');
      const circle = createElement2.appendChild(document.createElement('div'));
      circle.className = 'circle';
      pointBoxElement[i].querySelector('.circle').style.bottom = `calc(${el.value}% - 3px)`;
      
      const svg = pointBoxElement[i].appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
      svg.innerHTML = '<line class="line"></line>';
      svg.setAttribute('width', 40);
      svg.setAttribute('height', 150);
      svg.setAttribute('style', 'overflow: visible;');
      svg.querySelector('.line').setAttribute('x1', 20);
      svg.querySelector('.line').setAttribute('y1', 100 - el.value+'%');
      svg.querySelector('.line').setAttribute('x2', i < dataset.length - 1 ? 74 : 20);
      svg.querySelector('.line').setAttribute('y2', i < dataset.length - 1 ? 100 - dataset[i+1].value+'%' : 100 - el.value+'%');
      svg.querySelector('.line').setAttribute('stroke', '#ffb5cc');
      svg.querySelector('.line').setAttribute('stroke-width', 1);
    });
  }
}  
</script>

<style lang="scss">
#lineChart{
  height: 210px;
  padding-left: 40px;
  position: relative;
  overflow-x: scroll;

  .grid{
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ccc;

    .persent{
      width: 40px;
      padding-right: 8px;
      border-right: 1px solid #ccc;
      position: absolute;
      left: 0; top: 0;
      font-size: 14px;

      >div{
        height: 30px;
        line-height: 30px;
      }
    }
    .date{
      border-top: 1px solid #ccc;
      position: absolute;
      left: 40px;
      top: 179px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      word-break: keep-all;

      >div{
        min-width: 40px;
        margin: 4px 8px;
      }
    }
    .point{
      width: 100%;
      height: 150px;
      display: flex;
      position: relative;

      .pointBox{
        min-width: 40px;
        margin: 0 8px;
        position: relative;
        display: flex;
        justify-content: center;

        .circle{
          width: 6px;
          height: 6px;
          border-radius: 100%;
          position: absolute;
          text-align: center;
          background-color: #ffb5cc;
        }
      }
    }
  }
}
</style>